module.exports = __webpack_public_path__ + "static/media/paff-narrow.453e5e92.png";